const getters = {
  downloads: (state) => state.downloads, // descargas con paginacion
  paginate_downloads: (state) => state.paginate_downloads, // paginacion de las descargas
  limit_download: (state) => state.limit_download, // limite de las descargas
}

export default getters
